import { cn, triggerEvent } from "../../lib/utils.ts";
import { type FC } from "react";
import { NavLink, useLocation } from "react-router";
import { HouseIcon, CompassIcon, FlagIcon } from "lucide-react";
import Text from "../Text";
import { userRestaurantsState } from "@/store/userRestaurantsState.ts";
import { useTranslation } from "react-i18next";
import useDetectSizeDevice from "@/hooks/useDetectSizeDevice.ts";

const BASE_NAV_ITEM_MOBILE =
  "flex flex-col items-center justify-center w-full gap-[4px] px-[12px] h-[46px] py-[4px] rounded-[48px]";

const styleNavLinkForMobile = (isActive: boolean): string => {
  return isActive
    ? cn(BASE_NAV_ITEM_MOBILE, "bg-[#F7F8F9]")
    : BASE_NAV_ITEM_MOBILE;
};

const Nav: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { sm } = useDetectSizeDevice();

  const { data: restaurants } = userRestaurantsState();

  if (!sm)
    return (
      <nav
        className="grid grid-cols-3 place-content-center gap-[8px] px-[16px] w-[100vw] z-10 fixed bottom-[env(safe-area-inset-bottom)] left-[0px] right-[0px] bg-[#FFFFFF] h-[62px]"
        style={{
          borderTop: "1px solid #E0E0E0",
        }}
      >
        <NavLink
          className={({ isActive }) => styleNavLinkForMobile(isActive)}
          to="/"
        >
          <HouseIcon
            width={16}
            height={16}
            color={pathname === "/" ? "#0F62FE" : "#44546F"}
          />
          <Text
            fontWeight={400}
            fontSize={14}
            color={pathname === "/" ? "#0F62FE" : "#44546F"}
          >
            {t("home")}
          </Text>
        </NavLink>
        <NavLink
          onClick={() => {
            triggerEvent("Explorer Opened", {
              entry_point: "nav",
            });
          }}
          className={({ isActive }) => styleNavLinkForMobile(isActive)}
          to="/explorer"
        >
          <CompassIcon
            width={16}
            height={16}
            color={pathname.includes("/explorer") ? "#0F62FE" : "#44546F"}
          />
          <Text
            fontWeight={400}
            fontSize={14}
            color={pathname.includes("/explorer") ? "#0F62FE" : "#44546F"}
          >
            {t("explorer")}
          </Text>
        </NavLink>
        <NavLink
          onClick={() => {
            triggerEvent("Restaurants Opened", {
              entry_point: "nav",
            });
          }}
          className={({ isActive }) =>
            styleNavLinkForMobile(
              isActive ||
                (pathname.includes("/restaurant/") &&
                  !pathname.includes("/explorer") &&
                  restaurants !== null &&
                  restaurants.length > 6),
            )
          }
          to="/restaurants"
        >
          <FlagIcon
            width={16}
            height={16}
            color={
              pathname.includes("/restaurant") &&
              !pathname.includes("/explorer")
                ? "#0F62FE"
                : "#44546F"
            }
          />
          <Text
            fontWeight={400}
            fontSize={14}
            color={
              pathname.includes("/restaurant") &&
              !pathname.includes("/explorer")
                ? "#0F62FE"
                : "#44546F"
            }
          >
            {t("stores")}
          </Text>
        </NavLink>
      </nav>
    );

  return null;

  // return (
  //   <div
  //     className={cn(
  //       "overflow-hidden z-50 w-0 sm:w-[218px] sm:min-w-[218px] h-dvh bg-[white] sm:px-[12px] sm:py-[16px] shadow-(--boxshadow-nav) transition-(--transition-nav) sm:transition-none fixed top-(--height-header) sm:top-0 left-0 sm:relative",
  //     )}
  //   >
  //     <img
  //       alt="krunsh logo"
  //       src="/svg/krunsh-logo.svg"
  //       className="hidden sm:block"
  //     />
  //     <nav className="flex flex-col mt-[40px] gap-[8px]">
  //       <NavLink className={({ isActive }) => styleNavLink(isActive)} to="/">
  //         <HouseIcon width={24} height={24} color="#758195" />
  //         <Text fontWeight={600} fontSize={14} color="#44546F">
  //           {t("home")}
  //         </Text>
  //       </NavLink>
  //       <NavLink
  //         onClick={() => {
  //           triggerEvent("Explorer Opened", {
  //             entry_point: "nav",
  //           });
  //         }}
  //         className={({ isActive }) => styleNavLink(isActive)}
  //         to="/explorer"
  //       >
  //         <CompassIcon width={24} height={24} color="#758195" />
  //         <Text fontWeight={600} fontSize={14} color="#44546F">
  //           {t("explorer")}
  //         </Text>
  //       </NavLink>
  //       <NavLink
  //         onClick={() => {
  //           triggerEvent("Alerts Opened", {
  //             entry_point: "nav",
  //           });
  //         }}
  //         className={({ isActive }) => styleNavLink(isActive)}
  //         to="/alerts"
  //       >
  //         <Bell width={24} height={24} color="#758195" />
  //         <Text fontWeight={600} fontSize={14} color="#44546F">
  //           {t("alerts")}
  //         </Text>
  //         {NumberOfNotificationsUnRead > 0 && (
  //           <div className="bg-[#0F62FE] rounded-[50%] h-[16px] w-[16px] flex items-center justify-center absolute right-[8px]">
  //             <Text fontSize={12} fontWeight={600} color="white">
  //               {NumberOfNotificationsUnRead}
  //             </Text>
  //           </div>
  //         )}
  //       </NavLink>
  //       <NavLink
  //         onClick={() => {
  //           triggerEvent("Grid Builder Opened", {
  //             entry_point: "nav",
  //           });
  //         }}
  //         className={({ isActive }) => styleNavLink(isActive)}
  //         to="/grid-builder"
  //       >
  //         <Table width={24} height={24} color="#758195" />
  //         <Text fontWeight={600} fontSize={14} color="#44546F">
  //           Builder
  //         </Text>
  //       </NavLink>
  //       <NavLink
  //         onClick={() => {
  //           triggerEvent("Restaurants Opened", {
  //             entry_point: "nav",
  //           });
  //         }}
  //         className={({ isActive }) =>
  //           styleNavLink(
  //             isActive ||
  //               (pathname.includes("/restaurant/") &&
  //                 !pathname.includes("/explorer") &&
  //                 restaurants !== null &&
  //                 restaurants.length > 6),
  //           )
  //         }
  //         to="/restaurants"
  //       >
  //         <FlagIcon width={24} height={24} color="#758195" />
  //         <Text fontWeight={600} fontSize={14} color="#44546F">
  //           {t("my_stores")}
  //         </Text>
  //       </NavLink>

  //       {restaurants && restaurants.length > 0 && restaurants.length < 6 && (
  //         <>
  //           {/* <div
  //             className={cn(
  //               "cursor-pointer items-center sm:justify-between p-[8px] max-w-[218px]",
  //            ? "flex" : "hidden sm:flex"
  //             )}
  //             onClick={() => setOpenRestaurantsList((prevState) => !prevState)}
  //           >
  //             <div className="flex items-center gap-[8px]">
  //               <FlagIcon width={24} height={24} color="#758195" />
  //               <Text fontSize={14} fontWeight={600}>
  //                 Mes enseignes
  //               </Text>
  //             </div>

  //             <ChevronDownIcon
  //               width={24}
  //               height={24}
  //               color="#758195"
  //               className="ml-[38px] sm:ml-[auto]"
  //               style={{
  //                 transition: "transform 0.3s",
  //                 transform: openRestaurantsList
  //                   ? "rotate(180deg)"
  //                   : "rotate(0deg)",
  //               }}
  //             />
  //           </div> */}
  //           {openRestaurantsList &&
  //             restaurants.map((restaurant) => (
  //               <NavLink
  //                 key={`navlink-restaurant-${restaurant.id}`}
  //                 onClick={() => {}}
  //                 className={({ isActive }) => styleNavLink(isActive)}
  //                 to={generatePath("/restaurant/:restaurantId", {
  //                   restaurantId: restaurant.id,
  //                 })}
  //               >
  //                 <img
  //                   width={16}
  //                   height={16}
  //                   className="rounded-[50%]"
  //                   src={`/partner/${restaurant.platform.toLowerCase()}.png`}
  //                   alt={`logo of ${restaurant.platform}`}
  //                 />
  //                 <Text fontWeight={600} fontSize={14} color="#44546F">
  //                   {restaurant.name}
  //                 </Text>
  //               </NavLink>
  //             ))}
  //         </>
  //       )}

  //       <NavLink
  //         onClick={() => {
  //           triggerEvent("Upgrade CTA Clicked", {
  //             cta_location: "sidebar",
  //           });
  //         }}
  //         // className={({ isActive }) => styleNavLink(isActive)}
  //         to="/find-restaurant"
  //       >
  //         <Button variant="primaryOutlined">{t("add_my_stores")}</Button>
  //       </NavLink>

  //       {!stripeSubscription ||
  //       (stripeSubscription && stripeSubscription.cancelAtPeriodEnd) ? (
  //         <NavLink
  //           onClick={() => {}}
  //           to={"/upgrade"}
  //           style={{ width: "calc(100% - 24px)" }}
  //           className={cn("sm:hidden fixed bottom-[40px]")}
  //         >
  //           <Button className="w-full">{t("upgrade")}</Button>
  //         </NavLink>
  //       ) : null}
  //   </nav>
  // </div>
  // );
};

export default Nav;
